/**
 * СДЭК — официальный виджет v3
 * Расчёт курьерской доставки обрабатывается через validationFormInit.js -> /api/v2/delivery/costs
 */


function getCityFromCookie() {
  var match = document.cookie.split('; ').find(function(r) {
    return r.startsWith('user_city=');
  });
  if (!match) return null;
  try {
    return JSON.parse(decodeURIComponent(match.split('=').slice(1).join('=')));
  } catch (e) { return null; }
}

function initCdek() {
  const $btnCdek = $('.js-btn-cdek');
  if (!$btnCdek.length) return;

  $btnCdek.on('mfpOpen', function () {
    const deliveryRow = document.querySelector('.js-delivery-row');
    if (!deliveryRow) {
      console.error('СДЭК: не найден .js-delivery-row с данными корзины');
      return;
    }

    var savedCity = getCityFromCookie();

    // defaultLocation — центрирует карту
    var defaultLocation = savedCity
      ? savedCity.cdek_city
      : [30.31413, 59.93863];

    // cityCode — фильтрует ПВЗ по городу (числовой код CDEK)
    var widgetConfig = {
      root:            'forpvz',
      servicePath: savedCity && savedCity.cdek_code
        ? '/api/v2/cdek/widget_service?city_code=' + savedCity.cdek_code
        : '/api/v2/cdek/widget_service',
      apiKey:          window.YMAPS_API_KEY || '',
      from: {
        country_code: 'RU',
        city:         'Санкт-Петербург',
        postal_code:  197198,
        code:         137,
        address:      'ул. Красного Курсанта, д. 25B',
      },
      defaultLocation: defaultLocation,
      goods: [{
        length: +deliveryRow.dataset.depth  || 10,
        width:  +deliveryRow.dataset.width  || 10,
        height: +deliveryRow.dataset.height || 10,
        weight: +deliveryRow.dataset.weight || 500,
        price:  +deliveryRow.dataset.price  || 0,
      }],
      hideDeliveryOptions: { door: true, office: false },
      tariffs: { office: [138] },
      hideFilters: {
         have_cashless:    true,   // скрыть фильтр оплаты картой
         have_cash:        true,   // скрыть фильтр оплаты наличными
         is_dressing_room: true,   // скрыть фильтр примерочной
         type:             true,   // скрыть фильтр типа ПВЗ      
      },

      onReady: function() {
        var style = document.createElement('style');
        style.textContent = '#forpvz [data-v-a997d909].cdek-fptd2w { display: none !important; }';
        document.head.appendChild(style);
      },
      lang:     'rus',
      currency: 'RUB',
      onChoose: function (type, tariff, address) {
        try { onPvzChosen(type, tariff, address); }
        catch (e) { console.error('СДЭК onChoose ошибка:', e); }
      },
    };

    // Если есть код города — добавляем фильтрацию
    if (savedCity && savedCity.cdek_code) {
      widgetConfig.cityCode = savedCity.cdek_code;
    }

    try {
      new CDEKWidget(widgetConfig);
    } catch (e) {
      console.error('СДЭК: не удалось инициализировать виджет', e);
    }
  });
}

function onPvzChosen(type, tariff, address) {
  const price = tariff.delivery_sum;

  if (!price || price < 1) {
    alert('В данный момент невозможно узнать стоимость доставки. Попробуйте другой пункт.');
    return;
  }

  const table = document.querySelector('.cdek-table');
  if (table) table.style.display = 'block';

  const setEl = (id, val) => {
    const el = document.getElementById(id);
    if (el) el.innerHTML = val || '—';
  };

  setEl('address-cdek',      [address.city, address.address].filter(Boolean).join(', '));
  setEl('workschedule-cdek', address.work_time);
  setEl('phone-cdek',        Array.isArray(address.phones)
                               ? address.phones.map(p => p.number).join(', ')
                               : (address.phones || ''));
  setEl('period-cdek',       tariff.period_min === tariff.period_max
                               ? tariff.period_min
                               : `${tariff.period_min}–${tariff.period_max}`);

  $('.js-form-item-cdek').removeClass('form-item');

  const $input = $('.js-input-cdek');
  $input.val(address.code);
  $input.closest('.radio-wrap').attr('data-delivery-cost', price);

  if (typeof window.changePrices === 'function') window.changePrices(price);
  if (typeof window.validationAddressCart === 'function') window.validationAddressCart();

  $.magnificPopup.close();
}

export default initCdek;